import React from 'react';
import { cx } from '@milanote/roma/utils';
import { Menu, MenuSize } from '@milanote/roma';
import { GridListItem } from 'react-aria-components';
import { ImMNElement, MNElement } from '../../../../../common/elements/elementModelTypes';
import { getElementId, getTitle } from '../../../../../common/elements/utils/elementPropertyUtils';
import ListItemBoardIcon from '../../../popupPanel/listItems/ListItemBoardIcon';
import type { BoardLinkListBaseProps } from './boardLinkTypes';

export type BoardLinkItemProps = BoardLinkListBaseProps & {
    board: ImMNElement;
    size?: MenuSize;
};

const BoardLinkListItem: React.FC<BoardLinkItemProps> = ({ board, gridSize, onSelect, isSheet, size = 'sm' }) => {
    const boardId = getElementId(board);
    const title = getTitle(board) || '';

    return (
        <GridListItem
            id={boardId}
            textValue={title}
            onAction={() => onSelect(board)}
            className={cx('BoardLinkListItem w-full outline-hidden', 'py-0.5')}
        >
            {(state) => (
                <Menu.Base.ItemStructured
                    // Temporary casting until real data is fetched in WEB-16817
                    leading={<ListItemBoardIcon element={board as unknown as MNElement} size={4} gridSize={gridSize} />}
                    label={<span className="font-bold text-inherit">{title}</span>}
                    isSelected={false}
                    isDisabled={state.isDisabled}
                    isFocused={state.isFocused}
                    isFocusVisible={state.isFocusVisible}
                    isHovered={isSheet ? false : state.isHovered}
                    className={cx('cursor-pointer', size == 'sm' ? 'mx-0.5' : '')}
                    size={size}
                />
            )}
        </GridListItem>
    );
};

export default BoardLinkListItem;
